var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowItWorks1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 608,
    viewBox: "0 0 456 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1217_9671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 456,
    height: 608
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 608,
    rx: 40,
    fill: "#ECFFFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1217_9671)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 608,
    fill: "#ECFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6973 192.822C61.6973 176.234 84.8336 162.768 113.416 162.768C141.998 162.768 165.134 176.234 165.134 192.822",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.962 321.877C402.962 321.877 402.962 321.71 402.962 321.643V316.653H399.722C399.488 316.485 399.287 316.351 399.02 316.217L265.932 239.188C260.086 235.805 249.897 236.241 243.183 240.126L58.5827 346.962C57.3801 347.665 56.3779 348.436 55.5427 349.239H53.0039V360.827C53.0707 362.937 54.3401 364.913 56.9458 366.42L190.034 443.449C195.88 446.832 206.069 446.397 212.783 442.512L397.417 335.642C400.991 333.566 402.828 330.953 402.962 328.441V325.327V321.877Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.034 432.23L56.9461 355.201C51.1001 351.818 51.835 345.924 58.583 342.039L243.216 235.169C249.964 231.284 260.153 230.849 265.966 234.231L399.054 311.261C404.9 314.643 404.165 320.538 397.417 324.423L212.784 431.292C206.036 435.177 195.847 435.613 190.034 432.23Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.727 424.761L202.159 424.426L73.8145 350.143L250.163 248.063L250.731 248.398L379.076 322.681L202.727 424.761Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.431 417.26L72.8145 341.671L252.337 237.748L382.986 313.337L203.431 417.26Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.834 274.555L312.6 301.08",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.291 282.425L301.843 331.958",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.596 290.094L288.148 339.627",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.865 297.764L274.451 347.297",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.17 305.433L260.722 354.966",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.438 313.103L247.023 362.636",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.262 361.095L226.246 383.668",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.174 269.33L362.107 269.832L348.812 262.129C348.578 262.297 348.377 262.464 348.11 262.632C344.369 264.809 342.164 268.258 338.422 266.115C334.681 263.938 330.772 263.234 334.514 261.058C334.781 260.89 335.082 260.79 335.382 260.656V249.872L331.441 248.8L330.639 257.909L315.94 243.14C313.368 241.633 308.959 242.37 308.09 244.413L306.219 248.967L304.516 248.8V259.751C304.516 259.751 304.516 259.818 304.516 259.852C304.582 260.522 305.05 261.125 305.852 261.627L346.273 285.037C347.409 285.707 349.012 285.975 350.582 285.774L365.381 283.865C367.753 283.563 369.122 282.324 369.022 281.085V270.301L362.14 269.296L362.174 269.33Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.685 268.56L348.811 257.642C348.577 257.809 348.377 257.977 348.109 258.144C344.368 260.321 338.288 260.321 334.513 258.144C330.772 255.967 330.772 252.451 334.513 250.274C334.781 250.106 335.081 250.006 335.382 249.872L315.94 238.619C313.368 237.112 308.958 237.849 308.089 239.892L304.615 248.365C304.248 249.269 304.716 250.24 305.851 250.91L346.272 274.32C347.408 274.99 349.011 275.258 350.582 275.057L365.38 273.148C368.988 272.679 370.257 270.1 367.652 268.593L367.685 268.56Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.924 306.204L265.264 245.618C262.759 244.178 263.06 241.633 265.966 239.925L272.447 236.174C275.353 234.499 279.729 234.299 282.268 235.772L386.928 296.357C389.433 297.797 389.133 300.343 386.226 302.051L379.746 305.802C376.839 307.476 372.463 307.677 369.924 306.204Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.153 292.238L284.806 261.962C283.537 261.225 283.704 259.952 285.174 259.115L288.414 257.24C289.851 256.402 292.055 256.302 293.325 257.039L345.672 287.315C346.941 288.051 346.774 289.324 345.304 290.161L342.064 292.037C340.627 292.874 338.423 292.974 337.153 292.238Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.576 443.102C161.576 442.901 161.576 442.7 161.576 442.499V383.723L101.178 359.844L94.5638 360.715V420.094C94.497 421.802 95.4657 423.443 97.5703 424.682L139.929 449.265C144.405 451.843 152.189 451.509 157.333 448.528C160.006 446.987 161.442 445.011 161.576 443.136V443.102Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.929 389.885L97.5703 365.302C93.0939 362.724 93.6618 358.202 98.8063 355.222C103.951 352.241 111.734 351.906 116.211 354.485L158.569 379.067C163.045 381.646 162.478 386.167 157.333 389.148C152.189 392.129 144.405 392.464 139.929 389.885Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.74 410.515V423.334L116.761 421.034V407.668V407.364L116.549 407.146C114.191 404.718 112.652 401.181 112.652 398.291C112.652 396.252 113.385 394.877 114.518 394.217C115.642 393.562 117.178 393.629 118.942 394.653L118.942 394.653C120.626 395.628 122.168 397.288 123.291 399.235C124.414 401.182 125.083 403.356 125.083 405.324C125.083 407.086 124.497 408.403 123.633 409.087C123.05 409.538 122.318 409.765 121.49 409.765H120.74V410.515Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.474 341.452C114.363 340.026 115.719 338.912 117.287 338.288L117.164 338.441L117.058 338.572L117.019 338.735L116.217 342.051L116.197 342.135L116.196 342.221L116.03 361.259L115.292 362.969L112.084 363.359V346.246C112.084 344.548 112.577 342.878 113.472 341.454L113.472 341.454L113.474 341.452Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.945 384.493H143.705C141.366 384.493 139.429 382.584 139.429 380.206V363.46C139.429 354.753 133.082 343.734 125.565 339.38C123.093 337.94 120.788 337.505 119.552 338.208C118.316 338.912 117.581 341.155 117.581 344.002V360.748C117.581 363.092 115.677 365.035 113.305 365.035H110.065C107.727 365.035 105.789 363.126 105.789 360.748V344.002C105.789 336.701 108.662 330.874 113.673 327.96C118.684 325.08 125.164 325.482 131.445 329.132C142.535 335.562 151.221 350.633 151.221 363.46V380.206C151.221 382.55 149.317 384.493 146.945 384.493Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.629 297.026L203.63 306.303L197.183 288.854L187.629 297.026Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.583 287.783L82.4023 148.996C82.4023 148.996 82.3355 148.896 82.3021 148.862C81.6673 148.159 80.5984 147.824 79.1619 148.092C76.289 148.628 73.1489 151.274 72.1467 154.053C71.6122 155.561 72.2135 157.034 72.6144 157.503L186.962 296.424C187.296 296.826 187.73 297.127 188.265 297.294C188.933 297.529 189.701 297.562 190.537 297.395C193.343 296.892 196.282 294.381 197.251 291.701C197.786 290.228 197.385 288.654 196.583 287.749V287.783Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5688 149.13C81.8005 148.192 80.4977 147.858 78.961 148.125C76.1549 148.628 73.2152 151.14 72.2465 153.819C71.712 155.293 71.8456 156.632 72.6473 157.536C73.0148 157.938 73.4491 158.24 73.9836 158.441C74.6517 158.675 75.42 158.709 76.2552 158.541C79.0612 158.039 82.0009 155.527 82.9697 152.848C83.5042 151.374 83.3706 150.034 82.5688 149.13Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.953 207.371L178.643 275.559",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.103 192.822C165.103 209.41 141.967 222.876 113.385 222.876C84.8025 222.876 61.6992 209.41 61.6992 192.822",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks1);
export default __webpack_public_path__ + "static/media/howItWorks1.318e23903affb785382cf5dd93b683e6.svg";
export { ForwardRef as ReactComponent };